(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["page-press-template"]) return;
  try {
    
  const pressLoadMore = document.getElementById('load_more_press');
  const pressGridItems = Object.values(document.getElementsByClassName('Press__Item'));

  pressLoadMore.addEventListener('click', (event) => {
    pressGridItems.forEach(element => element.classList.remove('u-visually-hidden'));
    pressLoadMore.style.display = 'none';
  });

  } catch(e) { console.error(e); }
})();

})();
